<div *ngIf="dispatchDetails">
    <div class="order-summary-header">
        <div class="order-summary-header-inner">
            <div *ngIf="dispatchSigned else acceptLoadAssignmentHeader" class="header-left">
                <div class="page-name">Dispatch Sheet</div>
            </div>
            <ng-template #acceptLoadAssignmentHeader>
                <div class="header-left">
                    <div class="page-name">Accept Load Assignment</div>
                    <div class="page-description">Click I Agree and sign at the bottom.</div>
                </div>
            </ng-template>
            <div class="header-right">
                <div class="header-right-order">Order ID</div>
                <div id="order-id" class="header-right-number">#{{ dispatchDetails.id }}</div>
            </div>
        </div>
    </div>

    <div class="order-summary-main order-summary-main-top-header">

        <div class="order-summary-main-inner">
            <div class="order-summary-main-left">
                <div class="summary-header-block">
                    <div class="summary-header-block__header">Order Info</div>
                </div>
                <div class="info-block__base">
                    <div class="info-block__line--blue"></div>
                    <div class="info-block__main">
                        <div class="info-block__row">
                            <span class="info-block__row__header">Assigned At</span>
                            <span class="info-block__row__value">{{ dispatchDetails.assignedAt }} <span style="color: red">{{ configuration?.timeZone }}</span></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="order-summary-main-right">
                <div *ngIf="!dispatchSigned">
                   <div class="summary-header-block">
                        <div class="summary-header-block__header">Carrier Info</div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row">
                                <span class="info-block__row__header">Carrier Name</span>
                                <span class="info-block__row__value">{{ dispatchDetails.carrier.name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="dispatchSigned">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Acceptance Info</div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row">
                                <span class="info-block__row__header">Accepted At</span>
                                <span class="info-block__row__value">{{ dispatchDetails.loadAcceptedAt }} <span style="color: red">{{ dispatchDetails.loadAcceptedAtTimeZone }}</span></span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">Accepted By</span>
                                <span class="info-block__row__value">{{ dispatchDetails.signedBy }}</span>
                            </div>
                            <div class="info-block__row">
                                <div class="info-block__row__header">
                                    <button
                                        type="button"
                                        id="orderReportDownload"
                                        class="sign-button"
                                        [disabled]="downloadingPdf"
                                        (click)="downloadPdf()"
                                    >
                                        <span>{{ downloadingPdf ? 'Please Wait...' : 'Download PDF' }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <form
            id="changeOrderForm"
            method="post"
            *ngIf="signatureForm"
            [formGroup]="signatureForm">

            <div class="order-summary-main-inner">
                <div class="order-summary-main-left">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Broker Info</div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row">
                                <span class="info-block__row__header">Broker Name</span>
                                <span class="info-block__row__value">{{ dispatchDetails.broker.name }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">Broker MC #</span>
                                <span class="info-block__row__value">{{ dispatchDetails.broker.motorCarrierNumber }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">Broker Company Phone</span>
                                <span class="info-block__row__value">{{ dispatchDetails.broker.phone }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">Broker Fax</span>
                                <span class="info-block__row__value">{{ dispatchDetails.carrier.fax }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-summary-main-right">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header"></div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row">
                                <span class="info-block__row__header">Broker Address</span>
                                <span class="info-block__row__value">{{ dispatchDetails.broker.address?.address }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">Broker City</span>
                                <span class="info-block__row__value">{{ dispatchDetails.broker.address?.city }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">Broker Dispatch Contact</span>
                                <span class="info-block__row__value">{{ dispatchDetails.broker.dispatcherContact }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header"> Broker Dispatch Phone</span>
                                <span class="info-block__row__value">{{ dispatchDetails.broker.dispatcherPhone }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header"> Broker Dispatch Email</span>
                                <span class="info-block__row__value">{{ dispatchDetails.broker.dispatcherEmail }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="order-summary-main-inner">
                <div class="order-summary-main-left">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Origin</div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row" *ngIf="dispatchSigned">
                                <span class="info-block__row__header">Origin Contact Name</span>
                                <span class="info-block__row__value">{{ dispatchDetails.origin.contactName }}</span>
                            </div>
                            <div class="info-block__row" *ngIf="dispatchSigned">
                                <span class="info-block__row__header">Origin Contact Phone</span>
                                <span class="info-block__row__value">{{ dispatchDetails.origin.contactPhone }}</span>
                            </div>
                            <div class="info-block__row" *ngIf="dispatchSigned">
                                <span class="info-block__row__header">Origin Address</span>
                                <span class="info-block__row__value">{{ dispatchDetails.origin.address }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">Origin City</span>
                                <span class="info-block__row__value">{{ dispatchDetails.origin.city }}</span>
                            </div>
                            <div class="info-block__row" *ngIf="dispatchSigned">
                                <span class="info-block__row__header">Origin Country</span>
                                <span class="info-block__row__value">{{ dispatchDetails.origin.country }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-summary-main-right">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Destination</div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row" *ngIf="dispatchSigned">
                                <span class="info-block__row__header">Destination Contact Name</span>
                                <span class="info-block__row__value">{{ dispatchDetails.destination.contactName }}</span>
                            </div>
                            <div class="info-block__row" *ngIf="dispatchSigned">
                                <span class="info-block__row__header">Destination Contact Phone</span>
                                <span class="info-block__row__value">{{ dispatchDetails.destination.contactPhone }}</span>
                            </div>
                            <div class="info-block__row" *ngIf="dispatchSigned">
                                <span class="info-block__row__header">Destination Address</span>
                                <span class="info-block__row__value">{{ dispatchDetails.destination.address }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">Destination City</span>
                                <span class="info-block__row__value">{{ dispatchDetails.destination.city }}</span>
                            </div>
                            <div class="info-block__row" *ngIf="dispatchSigned">
                                <span class="info-block__row__header">Destination Country</span>
                                <span class="info-block__row__value">{{ dispatchDetails.destination.country }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="order-summary-main-inner">
                <div class="order-summary-main-center">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Cargo</div>
                        <div class="info-block__base mt-4">
                            <div class="info-block__line--blue"></div>
                            <div class="info-block__main">
                                <div class="info-block__row--horizontal">
                                    <div class="info-block__field">
                                        <span class="info-block__field__label">Transport Type:</span>
                                        <span class="info-block__field__value">{{ humanizeText(dispatchDetails.transportType) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="info-block__base" *ngFor="let vehicle of dispatchDetails.vehicles; let i = index">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row--horizontal">
                                <div class="info-block__field">
                                    <span class="info-block__field__value">{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }}</span>
                                </div>
                                <div class="info-block__field" *ngIf="vehicle.type">
                                    <span class="info-block__field__label">Type:</span>
                                    <span class="info-block__field__value">{{ humanizeText(vehicle.type) }}</span>
                                </div>
                                <div class="info-block__field" *ngIf="vehicle.inOperable !== undefined">
                                    <span class="info-block__field__label">Inoperable:</span>
                                    <span class="info-block__field__value">{{ vehicle.inOperable ? 'Yes' : 'No' }}</span>
                                </div>
                                <div class="info-block__field" *ngIf="vehicle.vin">
                                    <span class="info-block__field__label">VIN:</span>
                                    <span class="info-block__field__value">{{ vehicle.vin }}</span>
                                </div>
                                <div class="info-block__field" *ngIf="vehicle.licensePlate">
                                    <span class="info-block__field__label">License Plate:</span>
                                    <span class="info-block__field__value">{{ vehicle.licensePlate }}</span>
                                </div>
                                <div class="info-block__field" *ngIf="vehicle.licenseState">
                                    <span class="info-block__field__label">License State:</span>
                                    <span class="info-block__field__value">{{ vehicle.licenseState }}</span>
                                </div>
                                <div class="info-block__field" *ngIf="vehicle.color">
                                    <span class="info-block__field__label">Color:</span>
                                    <span class="info-block__field__value">{{ vehicle.color }}</span>
                                </div>
                                <div class="info-block__field" *ngIf="vehicle.weight">
                                    <span class="info-block__field__label">Weight:</span>
                                    <span class="info-block__field__value">{{ vehicle.weight }} lbs</span>
                                </div>
                                <div class="info-block__field" *ngIf="vehicle.lotNumber">
                                    <span class="info-block__field__label">Lot Number:</span>
                                    <span class="info-block__field__value">{{ vehicle.lotNumber }}</span>
                                </div>
                                <div class="info-block__field" *ngIf="vehicle.notes">
                                    <span class="info-block__field__label">Notes:</span>
                                    <span class="info-block__field__value">{{ vehicle.notes }}</span>
                                </div>
                                <div class="info-block__field" *ngIf="vehicle.mods">
                                    <span class="info-block__field__label">Mods:</span>
                                    <span class="info-block__field__value">{{ vehicle.mods }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="order-summary-main-inner">
                <div class="order-summary-main-left">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Pickup and Delivery Dates</div>
                        <div class="summary-header-block__desc">Contact Broker to change Pickup and Delivery terms.</div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row">
                                <span class="info-block__row__header">First Available Pickup Date</span>
                                <span class="info-block__row__value">{{ dispatchDetails.firstAvailablePickup }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">Pickup Date</span>
                                <span class="info-block__row__value">{{ dispatchDetails.pickupDate }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">Pickup Window</span>
                                <span class="info-block__row__value">{{ humanizeText(dispatchDetails.pickupWindow) }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">Delivery Date</span>
                                <span class="info-block__row__value">{{ dispatchDetails.deliveryDate }}</span>
                            </div>
                            <div class="info-block__row">
                                <span class="info-block__row__header">Delivery Window</span>
                                <span class="info-block__row__value">{{ humanizeText(dispatchDetails.deliveryWindow) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-summary-main-right">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Price and Payment</div>
                        <div class="summary-header-block__desc"></div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row">
                                <span class="info-block__row__header">Total Carrier Pay</span>
                                <span class="info-block__row__value">{{ dispatchDetails.price.totalPrice | currency }}</span>
                            </div>
                            <div class="info-block__row" *ngFor="let payment of dispatchDetails.price.payments">
                                <span class="info-block__row__header">{{ payment.key }}</span>
                                <span class="info-block__row__value">{{ payment.value }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="order-summary-main-inner">
                <div class="order-summary-main-left">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Additional Info</div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row">
                                <span class="info-block__row__header">Load Specific Terms</span>
                                <span class="info-block__row__value">{{ dispatchDetails.messageFromBroker }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-summary-main-right">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header"></div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__row">
                                <span class="info-block__row__header">Special Instructions</span>
                                <span class="info-block__row__value">{{ dispatchDetails.specialInstructions }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="order-summary-main-inner">
                <div class="order-summary-main-full-width">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Additional Terms</div>
                    </div>
                    <div class="info-block__base">
                        <div class="info-block__line--blue"></div>
                        <div class="info-block__main">
                            <div class="info-block__column">
                                <span class="info-block__row__header">Broker Contract Terms</span>
                                <span class="info-block__row__value-large-size mt-2" [innerHTML]="dispatchDetails.brokerContractTerms">{{ dispatchDetails.brokerContractTerms }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="order-summary-main-inner"
                *ngIf="!dispatchSigned">
                <div class="order-summary-main-center order-summary-main-center--narrow">
                    <div class="summary-header-block">
                        <div class="summary-header-block__header">Acceptance</div>
                    </div>
                    <div class="header-block__desc mb-4">
                        <span class="info_important">*</span>By selecting "I Agree" and entering my full name as a binding electronic signature,
                        I understand that an electronic signature has the same legal effect and can be enforced
                        in the same way as a written signature. Furthermore, I hereby accept terms and conditions
                        of service as described in the "Terms & Conditions" section below.
                    </div>
                    <div
                        *ngIf="!dispatchSigned"
                        class="mt-4">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                [formControl]="signatureControls.agree"
                                id="IAgreeCheckbox">
                            <label
                                class="form-check-label"
                                for="IAgreeCheckbox">
                                I Agree
                            </label>
                        </div>
                    </div>
                    <div
                        id="AcceptanceHiddenUnlessAgreedFields"
                    >
                        <div class="mt-4 border-container form-field-container">
                            <span class="border-text">Electronic signature</span>
                            <app-signature-input
                                inputId="signedBy"
                                placeholder="Electronic signature (Your full name)*"
                                [externalControl]="signatureControls.signedBy"
                                [formControl]="signatureControls.signedBy">
                            </app-signature-input>
                        </div>

                        <div class="mt-4 border-container">
                            <span class="border-text">Your IP address</span>
                            <input class="form-control" type="text" [formControl]="signatureControls.ip">
                        </div>

                        <div class="mt-4 border-container">
                            <span class="border-text">Agreed to terms on this day</span>
                            <input class="form-control" type="text" id="disabledAgreedToTerms" [formControl]="signatureControls.signedOn">
                        </div>
                    </div>
                </div>
            </div>

        </form>

        <div
            *ngIf="!dispatchSigned"
            class="order-summary-main order-summary-main-bottom-header">
            <div class="order-summary-main-inner">
                <div class="order-summary-main-button-container mt-5 mb-5">
                    <div class="order-summary-main-button">
                        <button
                            type="button"
                            id="signDispatchSheetButton"
                            class="sign-button"
                            [disabled]="!signatureControls.agree.value || signingInProgress"
                            (click)="submit()"
                        >
                            <span>{{ signingInProgress ? 'Please Wait...' : 'Sign Dispatch Sheet' }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
